// extracted by mini-css-extract-plugin
export var deliveryRow = "_t8-a";
export var fixedHeight = "_t8-4";
export var freightLogo = "_t8-9";
export var fullWidth = "_t8-3";
export var priceColumn = "_t8-5";
export var radioSelected = "_t8-7";
export var radioUnselected = "_t8-6";
export var selectedOption = "_t8-2";
export var selectedOptionContainer = "_t8-1";
export var selection = "_t8-0";
export var tallSkeletonText = "_t8-8";